/* ==========================================================================
   ModalSearcher > Client > Store > Actions
   ========================================================================== */

/* Types */
const DESTROY = 'MODAL_SEARCHER::DESTROY';
const SET_TITLE = 'MODAL_SEARCHER::SET_TITLE';
const SET_IMAGE = 'MODAL_SEARCHER::SET_IMAGE';
const SET_PRICE = 'MODAL_SEARCHER::SET_PRICE';
const SET_SEARCHER = 'MODAL_SEARCHER::SET_SEARCHER';

/* Actions */
const destroy = () => ({ type: DESTROY });
const setTitle = payload => ({ type: SET_TITLE, payload });
const setImage = payload => ({ type: SET_IMAGE, payload });
const setPrice = payload => ({ type: SET_PRICE, payload });
const setSearcher = payload => ({ type: SET_SEARCHER, payload });

/* Exports */
module.exports = {
    types: {
        DESTROY,
        SET_TITLE,
        SET_IMAGE,
        SET_PRICE,
        SET_SEARCHER
    },
    actions: {
        destroy,
        setTitle,
        setImage,
        setPrice,
        setSearcher
    }
};
